// extracted by mini-css-extract-plugin
export var blogtitle = "layout-module--blogtitle--cdbc3";
export var rssicon = "layout-module--rssicon--cd73f";